export const EventType = {
	STANDALONE_EVENT: "STANDALONE_EVENT",
	CURRICULUM: "CURRICULUM",
	CURRICULUM_EVENT: "CURRICULUM_EVENT",
};
